import Api from '@/model/api'

const state = ({
  searchData: {}
})

const getters = {
  getSearchData: state => state.searchData
}

const actions = {
  searchData ({ commit }) {
    Api.getData()
    .then((response) => {
      commit('searchData', response.data)
    })
    .catch(() => {})
  }
}

const mutations = {
  searchData (state, payload) {
    state.searchData = payload
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}